import { useState } from "react";
import Swal from "sweetalert2";
import {
    Box,
    Typography,
    IconButton,
    Stack,
    Chip,
    Divider,
} from "@mui/material";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RestorePageIcon from "@mui/icons-material/RestorePage";
import TaskIcon from '@mui/icons-material/Task';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';

import { formatToLongDate } from "../../utils/formatToLongDate";
import EditList from "./EditList";

const apiUrl = process.env.REACT_APP_API_URL;

const FolderCard = ({ list, openList, setOrderList }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const [openEditList, setOpenEditList] = useState(false);

    const handleClickMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleFunctionMenu = async (typeMenu) => {

        handleCloseMenu();

        let updateTo = "";

        if (typeMenu === "marking") {
            updateTo = "Marking";
        } else if (typeMenu === "update") {
            updateTo = "Update";
        } else if (typeMenu === "completed") {
            updateTo = "Completed";
        } else if (typeMenu === "rename") {
            setOpenEditList(true);
            return;
        } else if (typeMenu === "toDelete") {
            handleDeleteList();
            return;
        }

        try {

            const response = await fetch(`${apiUrl}manage_list/edit_list_status.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        listId: list.ListID,
                        remarks: updateTo,
                    }),
                }
            );

            const result = await response.json();

            if (result.status === "success") {

                setOrderList(prev =>
                    updateListField(
                        prev,
                        list.ListID,
                        "Remarks",
                        updateTo
                    )
                );

                return;

            }

            Swal.fire({
                text: result.message,
                icon: "error",
            });

        } catch (error) {

            Swal.fire({
                title: "Server Error!",
                text: error,
                icon: "error",
            });

            console.error(error);
        }
    };

    const updateListField = (
        orders,
        listID,
        field,
        value
    ) => {
        return orders.map(order =>
            order.ListID === listID
                ? {
                    ...order,
                    [field]: value,
                }
                : order
        );
    };

    const handleDeleteList = async () => {

        Swal.fire({
            title: "Confirm delete?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
        }).then((result) => {

            if (result.isConfirmed) {
                console.log("deleted");
            }
        });
    };

    return (
        <>
            <Box
                onClick={() => openList(list)}
                sx={{
                    width: "100%",
                    minWidth: 330,
                    cursor: "pointer",
                    transition: "0.2s ease",

                    "&:hover .folder-body": {
                        backgroundColor: "#f1f5f9",
                        boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
                        transform: "translateY(-2px)",
                    },
                }}
            >
                {/* Folder Body */}
                <Box
                    className="folder-body"
                    sx={{
                        position: "relative",
                        backgroundColor: "#F8FAFC",
                        border: "1px solid #E2E8F0",
                        borderRadius: 1,
                        p: 2,
                        overflow: "hidden",
                        transition: "box-shadow 0.2s ease, transform 0.2s ease",

                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "3px",
                            backgroundColor: "#3B82F6",
                        },
                    }}
                >
                    {/* TOP */}
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start"
                    >
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    color: "#222",
                                    lineHeight: 1.2,
                                }}
                            >
                                {list.ListName || "--"}
                            </Typography>

                            <Typography
                                style={{
                                    display: "inline-flex",
                                    padding: "2px 0px",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: "#374151",
                                }}
                            >
                                {formatToLongDate(list.DateCreated)}
                            </Typography>
                        </Box>

                        {/* MENU BUTTON */}
                        <IconButton
                            className="menu-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleClickMenu(e);
                            }}
                            size="small"
                            sx={{
                                opacity: 0.7,
                                transition: "0.2s ease",
                                borderRadius: 1,
                                border: "1px solid #d5d5d5",
                                backgroundColor: "#f8f8f8",

                                "&:hover": {
                                    backgroundColor: "#e7e7e7",
                                },
                            }}
                        >
                            <MoreHorizIcon
                                sx={{
                                    fontSize: 18,
                                    color: "#555",
                                }}
                            />
                        </IconButton>
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    {/* BOTTOM */}
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#777",
                            }}
                        >
                            Items: {list.TotalItems || 0}
                        </Typography>

                        <Chip
                            label={list.Remarks || "Normal"}
                            size="small"
                            sx={{
                                height: 22,
                                fontSize: 11,
                                borderRadius: 1,
                                fontWeight: 600,

                                backgroundColor:
                                    list.Remarks === "New"
                                        ? "#E3F2FD"
                                        : list.Remarks === "Update"
                                            ? "#FFF8E1"
                                            : list.Remarks === "Marking"
                                                ? "#F3E5F5"
                                                : list.Remarks === "Completed"
                                                    ? "#E8F5E9"
                                                    : "#F5F5F5",

                                color:
                                    list.Remarks === "New"
                                        ? "#1565C0"
                                        : list.Remarks === "Update"
                                            ? "#F57F17"
                                            : list.Remarks === "Marking"
                                                ? "#7B1FA2"
                                                : list.Remarks === "Completed"
                                                    ? "#2E7D32"
                                                    : "#616161",
                            }}
                        />
                    </Stack>
                </Box>
            </Box>

            {/* MENU */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        px: 1,
                        mt: 1,
                        minWidth: 220,
                        borderRadius: 1.2,
                        border: "1px solid #e0e0e0",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                        overflow: "hidden",

                        "& .MuiMenuItem-root": {
                            gap: 1.2,
                            py: 1.1,
                            fontSize: 14,
                            transition: "0.15s ease",

                            "&:hover": {
                                backgroundColor: "#e5effa",
                            },
                        },
                    },
                }}
            >
                {list.Remarks === "Marking" && (
                    <MenuItem sx={{ borderRadius: 1 }} onClick={() => handleFunctionMenu("completed")}>
                        <TaskIcon
                            sx={{ fontSize: 18 }}
                            color="success"
                        />
                        Set as Completed
                    </MenuItem>
                )}

                {list.Remarks === "New" && (
                    <MenuItem sx={{ borderRadius: 1 }} onClick={() => handleFunctionMenu("update")}>
                        <RestorePageIcon
                            sx={{ fontSize: 18 }}
                            color="primary"
                        />
                        Set for Update
                    </MenuItem>
                )}

                {(list.Remarks === "Update" || list.Remarks === "New" || list.Remarks === "Completed") && (
                    <MenuItem sx={{ borderRadius: 1 }} onClick={() => handleFunctionMenu("marking")}>
                        <BookmarkAddedIcon
                            sx={{ fontSize: 18 }}
                            color="warning"
                        />
                        Set for Marking
                    </MenuItem>
                )}

                <MenuItem sx={{ borderRadius: 1 }} onClick={() => handleFunctionMenu("rename")}>
                    <EditDocumentIcon
                        sx={{ fontSize: 18 }}
                        color="info"
                    />
                    Edit List
                </MenuItem>

                <Divider />

                <MenuItem
                    onClick={() => handleFunctionMenu("toDelete")}
                    sx={{
                        borderRadius: 1,
                        color: "error.main",

                        "&:hover": {
                            backgroundColor: "#ffebee !important",
                        },
                    }}
                >
                    <DeleteForeverIcon
                        sx={{ fontSize: 18 }}
                        color="error"
                    />
                    Delete
                </MenuItem>
            </Menu>

            {/* EDIT LIST INFO */}
            <EditList
                open={openEditList}
                onClose={() => setOpenEditList(false)}
                list={list}

                onUpdate={(val) =>
                    setOrderList(prev =>
                        prev.map(item =>
                            item.ListID === list.ListID
                                ? {
                                    ...item,
                                    ListName: val.ListName,
                                    DateCreated: val.DateCreated,
                                }
                                : item
                        )
                    )
                }
            />

        </>
    );
};

export default FolderCard;